import React from "react";
import { ReactChildrenProps } from "../types/ReactChildrenProps";
import classNames from "classnames";
import styles from "./modal.module.scss";
import ReactDOM from "react-dom";

export interface ModalProps extends ReactChildrenProps {
    isOpen: boolean;
    withOverlay?: boolean;
    usePortal?: boolean;
}

export const Modal: React.FC<React.PropsWithChildren<ModalProps>> = (props: ModalProps) => {
    const wrapperClassNames = classNames({
        [styles.wrapperWithOverlay]: props.withOverlay,
        [styles.wrapper]: !props.withOverlay,
    });

    const renderContent = () => {
        return (
            <div className={wrapperClassNames}>
                <div className={props.withOverlay ? styles.contentWithOverlay : styles.content}>{props.children}</div>
            </div>
        );
    };

    return props.isOpen
        ? props.usePortal
            ? ReactDOM.createPortal(renderContent(), document.querySelector("[id='portals']") || document.body)
            : renderContent()
        : null;
};

export default Modal;
